const updateSettings = async (json, store) => {
    const { http, survey, surveyToken } = store
    const { id } = survey

    try {
        const response = await http.put(`/api/survey/${id}/settings`, JSON.stringify(json), surveyToken)
        console.log(response)
        if (response.msg === 'Success') {
            store.addNotification({ body: 'Survey updated', level: 'success' })
        } else {
            store.handleError({ body: response.detail, level: 'error' })
        }
    } catch (e) {
        console.log(e)
        store.handleError({ body: e, level: 'error' })
    }
}

export default {
    updateSettings,
}
